/**
 * Remove a trailing ":<suffix>" tail from a translated label.
 *
 * Translated inspection-detail and zone-layout names sometimes ship from the
 * backend with a build/version suffix appended after a colon, e.g.:
 *   "STANDARD/STRAIGHT TRUCK: DTN2020H-3.1.1"        → "STANDARD/STRAIGHT TRUCK"
 *   "TRACTOR ZONES ONLY 2 (PRE-TRIP): DTN2020H-3.1.1" → "TRACTOR ZONES ONLY 2 (PRE-TRIP)"
 *
 * Splits on the FIRST colon. Trailing whitespace left over before the colon is
 * trimmed. Values without a colon are returned unchanged. null/undefined are
 * returned as-is so callers can stay null-safe.
 */
export const stripAfterColon = (value: string): string => {
	if (!value) return value;
	const idx = value.indexOf(":");
	return idx === -1 ? value : value.substring(0, idx).trimEnd();
};
